export const MAX_INDENT_ALLOWED = 3;
export const MAX_EXPANDABLE_INDENT_ALLOWED = 1;

export const LIST_ITEM_TEST_ID = 'list-item';
export const CHECKED_ICON_TEST_ID = 'checked-icon';
export const UNCHECKED_ICON_TEST_ID = 'unchecked-icon';
export const NUMBER_TEST_ID = 'number';
export const NESTED_TEST_ID = `nested`;
